/**
 * Design rule: 1024px and wider docks the drawer beside the editor; below it
 * the same panel is a full-height sheet under the header. The Sheet portal
 * only exists below the breakpoint so its overlay and dialog leave the
 * accessibility tree on desktop.
 */
export function previousNotesSheetState(
  requestedOpen: boolean,
  isDesktop: boolean,
): { mounted: boolean; open: boolean } {
  return {
    mounted: !isDesktop,
    open: requestedOpen,
  };
}
